export default "__VITE_ASSET__CNF1Xx94__"